<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-08-04 13:34:04
 * @LastEditTime: 2023-06-26 14:09:31
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" :model="dataForm" :rules="formRules" autocomplete="off" scrollToFirstError>
    <dc-layout-card title="基础信息" :span="6">
      <dc-form-item label="客户名称" name="customerName">
        <CosInputTianyancha
          v-model:value="dataForm.customerName"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          appId="cos_lbu"/>
      </dc-form-item>
      <dc-form-item label="ID" v-if="props.type === 'view'">
        <CosInput v-model:value="dataForm.clueId" view/>
      </dc-form-item>
      <dc-form-item label="状态" name="clueStatus">
        <template #label>
          状态
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <div v-for="item in clueStatusEnumComputed" :key="item.value">
                <p v-if="item.desc">{{ item.label }}{{ item.desc ? `：${item.desc}` : '' }}</p>
              </div>
            </template>
            <ExclamationCircleOutlined style="margin-left: 2px; font-size: 14px"/>
          </a-tooltip>
        </template>
        <CosSelect
          v-model:value="dataForm.clueStatus"
          :options="clueStatusEnumComputed"
          :disabled="!props.isEdit"
          placeholder="请选择"
          allowClear
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="来源渠道" name="channel" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="dataForm.channel"
            :cosDes="dataForm.channelExplain"
            appId="cos_lbu"
            paramCode="lbu_source_channel"
            :status="props.type === 'view' ? undefined : 0"
            :disabled="!props.isEdit || channelDisabled"
            :view="props.type === 'view'"
            style="width: 33%"
          />
          <dc-form-item name="channelExplain" :span="24" style="width: 67%" class="last-compact">
            <CosInput
              v-model:value="dataForm.channelExplain"
              :maxlength="100"
              :disabled="!props.isEdit || channelDisabled"
              :view="props.type === 'view'"
            />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item label="客户负责人" name="follower">
        <UserSelect
          permission
          v-model:value="dataForm.follower"
          defaultValue="me"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          placeholder="请选择"
          allowClear
          @change="handleFollowerChange"
        />
      </dc-form-item>
      <dc-form-item label="客户类型" name="customerType">
        <CosSelect
          v-model:value="dataForm.customerType"
          :options="customerTypeEnum"
          :disabled="!props.isEdit"
          placeholder="请选择"
          allowClear
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="客户区域" name="customerRegion">
        <CustomerAreaCascader
          appId="cos_lbu"
          v-model:value="dataForm.customerRegion"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="客户合同地址" name="customerAddress">
        <CosInput
          v-model:value.trim="dataForm.customerAddress"
          :maxlength="200"
          :disabled="true"
          placeholder="请输入"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="客户标签">
        <CustomerLabelCascader
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          type="search"
          appId="cos_lbu"
          v-model:ids="dataForm.labelIdList"
          :value="dataForm.labelIdList"
          allowClear/>
      </dc-form-item>
      <dc-form-item label="业务类型" name="businessType">
        <CosSelect
          v-model:value="dataForm.businessType"
          :options="businessTypeEnum"
          :disabled="!props.isEdit"
          placeholder="请选择"
          allowClear
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        name="futureContactTime"
        label="未来联系时间"
        :rules="isFutureClue ? formRules.futureContactTime : []"
        v-if="isFutureClue"
      >
        <CosSingleDateTimePicker
          v-model:startTime="dataForm.futureContactTime"
          :isRange="false"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <!-- <dc-form-item name="customerAddress" label="客户详细地址">
        <MapModal
          v-model:address="dataForm.customerAddress"
          v-model:geoPoint="dataForm.geoPoint"
          :view="props.type === 'view'"
        ></MapModal>
      </dc-form-item> -->
      <template v-if="props.type === 'view'">
        <dc-form-item label="客户识别码">
          <CosInput v-model:value="dataForm.customerSerial" view/>
        </dc-form-item>
        <dc-form-item label="未跟进天数">
          <CosInput v-model:value="dataForm.notFollowDayNum" view/>
        </dc-form-item>
        <dc-form-item label="创建人">
          <CosInput v-model:value="dataForm.createByName" view/>
        </dc-form-item>
        <dc-form-item label="创建时间">
          <CosInput v-model:value="dataForm.createTime" view/>
        </dc-form-item>
        <dc-form-item label="首次领取时间">
          <CosInput v-model:value="dataForm.firstReceiveTime" view/>
        </dc-form-item>
        <dc-form-item label="最后一次领取时间">
          <CosInput v-model:value="dataForm.lastReceiveTime" view/>
        </dc-form-item>
        <dc-form-item label="转为潜在时间">
          <CosInput v-model:value="dataForm.stageChangeTime" view/>
        </dc-form-item>
        <dc-form-item label="更新时间">
          <CosInput v-model:value="dataForm.updateTime" view/>
        </dc-form-item>
      </template>
    </dc-layout-card>

    <dc-layout-card title="联系人信息" :span="6">
      <dc-form-item label="联系人姓名" :name="['contact', 'name']" :rules="formRules.contactName">
        <CosInput
          v-model:value="dataForm.contact.name"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        label="手机号"
        :name="['contact', 'mobile']"
        :rules="{required: dataForm.businessType === 1, validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef, dataForm.businessType === 1)}"
      >
        <CosInput
          v-model:value="dataForm.contact.mobile"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        label="邮箱"
        :name="['contact', 'email']"
        :rules="{validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef, dataForm.businessType === 1)}"
      >
        <CosInput
          v-model:value="dataForm.contact.email"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        label="微信号"
        :name="['contact', 'wechat']"
        :rules="{required: dataForm.businessType === 1, validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef, dataForm.businessType === 1)}"
      >
        <CosInput
          v-model:value="dataForm.contact.wechat"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        label="QQ号"
        :name="['contact', 'qq']"
        :rules="{validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef, dataForm.businessType === 1)}"
      >
        <CosInput
          v-model:value="dataForm.contact.qq"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        label="固定电话"
        :name="['contact', 'tel']"
        :rules="{validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef, dataForm.businessType === 1)}"
      >
        <CosInput
          v-model:value="dataForm.contact.tel"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="传真号" :name="['contact', 'fax']">
        <CosInput
          v-model:value="dataForm.contact.fax"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="性别" :name="['contact', 'sex']">
        <CosRadioGroup v-model:value="dataForm.contact.sex" :options="genderEnum" :view="props.type === 'view'"/>
      </dc-form-item>
      <dc-form-item label="角色" :name="['contact', 'jobRole']" :rules="formRules.selectNumber">
        <CosSelect
          v-model:value="dataForm.contact.jobRole"
          :options="linkRoleTypeEnum"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          placeholder="请选择"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="职务" :name="['contact', 'jobDuty']" :rules="formRules.selectNumber">
        <ParamCodesSelect
          v-model:value="dataForm.contact.jobDuty"
          :options="paramCodeData.lbu_department_title"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item
        label="备注"
        :span="12"
        name="remark"
      >
        <CosInput
          v-model:value="dataForm.contact.remark"
          :maxlength="2000"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="签到地址（添加后才能签到打卡）" :span="6">
      <template #title>
        <div style="display: flex; align-items: center; height: 24px; margin-bottom: 13px">
          <div class="dc-card-header-defaut-line"></div>
          <p style="font-size: 16px; font-weight: 500">签到地址</p>
          <span style="color: #999; font-size: 12px">（添加后才能签到打卡）</span>
          <div style="flex: 1 1 0%; text-align: right">
            <a-button type="primary" ghost @click="handleAddressAdd(dataForm.visitAddress)" v-if="props.isEdit"
            >新增
            </a-button
            >
          </div>
        </div>
      </template>
      <MultipleItem :view="props.type === 'view'" :line="false">
        <template v-for="(item, index) in dataForm.visitAddress" :key="index">
          <dc-form-item
            :label="index ? '' : '签到地址'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'addressName']"
            :rules="[
            { validator: (rule:any, value:number) => checkAddressValidate(rule, value, dataForm.visitAddress, 'addressTag', '请选择') }
          ]"
          >
            <MapModal
              v-model:address="item.addressName"
              v-model:geoPoint="item.geoPoint"
              :view="props.type === 'view'"
            ></MapModal>
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '补充地址'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'suppAddress']"
          >
            <CosInput v-model:value="item.suppAddress" :view="props.type === 'view'"></CosInput>
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '地址类型'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'addressTag']"
            :rules="[
            { validator: (rule:any, value:number) => checkAddressValidate(rule, value, dataForm.visitAddress, 'addressName', '请输入') }
          ]"
          >
            <div class="flex">
              <ParamCodesSelect
                :options="paramCodeData.lbu_sign_in_address_label"
                v-model:value="item.addressTag"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
                allowClear
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.visitAddress && dataForm.visitAddress.length > 1"
                @click="handleAddressAddDel(index, dataForm.visitAddress)"
              >删除
              </a-button
              >
              <a-checkbox style="padding: 3px 0 0 12px; width: 150px;" :disabled="props.type === 'view'"
                          :checked="item.mainAddressFlag === 1" @change="clearMainAddressFlag(index)">主要
              </a-checkbox>
            </div>
          </dc-form-item>
          <a-col :span="6"/>
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="业务信息" :span="6">
      <dc-form-item label="业务收入等级">
        <ParamCodesSelect
          v-model:value="dataForm.business.monthIncome"
          :options="paramCodeData.lbu_important"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="年销售GMV(元)">
        <CosInputNumber
          v-model:value="dataForm.business.annualSales"
          cos-type="money"
          :min="0"
          :maxlength="15"
          :precision="2"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="总TPR（票数/月）">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>总潜力业务量（票数/月）</p>
            </template>
            <span>总TPR（票数/月）</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
          </a-tooltip>
        </template>
        <CosInput
          v-model:value="tprPotential"
          placeholder="自动计算"
          :maxlength="100"
          :disabled="props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="总TPR（元/月）">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>总潜力物流费用（元/月）</p>
            </template>
            <span>总TPR（元/月）</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
          </a-tooltip>
        </template>
        <CosInput
          :value="tprTotal"
          placeholder="自动计算"
          :maxlength="100"
          :disabled="props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="总TPR（KG/月）" v-if="dataForm.businessType === 1">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>总潜力重量（KG/月）</p>
            </template>
            <span>总TPR（KG/月）</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
          </a-tooltip>
        </template>
        <CosInput
          :value="totalTprWeight"
          placeholder="自动计算"
          :maxlength="100"
          :disabled="props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <template v-if="props.type === 'view'">
        <dc-form-item label="主账号上月发货票数">
          <CosInputNumber
            v-model:value="dataForm.business.uitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="主账号去年上月发货票数">
          <CosInputNumber
            v-model:value="dataForm.business.lyUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="主账号前三个月平均发货票数">
          <template #label>
            <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
              <template #title>
                <p>不含上个月，即前第2到第4个月</p>
              </template>
              <span>主账号前三个月平均发货票数</span>
              <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
            </a-tooltip>
          </template>
          <CosInputNumber
            v-model:value="dataForm.business.avgQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="当前账号上月发货票数">
          <CosInputNumber
            v-model:value="dataForm.business.ctUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="当前账号去年上月发货票数">
          <CosInputNumber
            v-model:value="dataForm.business.ctLyUitQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="当前账号前三个月平均发货票数">
          <template #label>
            <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
              <template #title>
                <p>不含上个月，即前第2到第4个月</p>
              </template>
              <span>当前账号前三个月平均发货票数</span>
              <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
            </a-tooltip>
          </template>
          <CosInputNumber
            v-model:value="dataForm.business.ctAvgQty"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="总OPR金额">
          <CosInputNumber
            v-model:value="dataForm.business.totalOprAmount"
            cos-type="money"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="总OPR票数">
          <CosInputNumber
            v-model:value="dataForm.business.totalOprMau"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="总OPR重量">
          <CosInputNumber
            v-model:value="dataForm.business.totalOprWeight"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
        <dc-form-item label="总OPR方数">
          <CosInputNumber
            v-model:value="dataForm.business.totalOprCube"
            :min="0"
            :maxlength="15"
            view
          />
        </dc-form-item>
      </template>
    </dc-layout-card>

    <dc-layout-card title="在售平台" :span="6" name="platform">
      <template #subTitle v-if="props.isEdit">
        <a-button type="primary" ghost @click="handleSalePlatformAdd()">新增</a-button>
      </template>
      <MultipleItem :view="props.type === 'view'" :line="false">
        <template v-for="(item, index) in dataForm.business.saleInfo" :key="index">
          <dc-form-item
            :label="index ? '' : '在售电商平台'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'saleInfo', index, 'salePlatformId']"
            :rules="[{ required: isPerfect, validator: (rule:any, value:number) => checkValidate(rule, value, dataForm.business.saleInfo, 'percent', '请选择') }]"
          >
            <ParamCodesSelect
              v-model:value="item.salePlatformId"
              :options="paramCodeData.lbu_sale_platform"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              allowClear
              @change="onSalesSelect(item,index)"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '在售平台占比(%)'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'saleInfo', index, 'percent']"
            :rules="[{ required: isPerfect, validator: (rule, inputValue) => percentValidate(rule, inputValue, item)}]"
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.percent"
                :min="0"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
                @change="onSalesInput"
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.business.saleInfo && dataForm.business.saleInfo.length > 1"
                @click="handleSalePlatformDel(index)"
              >删除
              </a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12"/>
        </template>
      </MultipleItem>
    </dc-layout-card>

    <dc-layout-card title="目的地国家" :span="4">
      <template #subTitle v-if="props.isEdit">
        <a-button type="primary" ghost @click="handleDemandInfoAdd()">新增</a-button>
      </template>
      <MultipleItem :view="props.type === 'view'" :line="false">
        <template v-for="(item, index) in dataForm.business.demandInfo" :key="index">
          <dc-form-item
            :label="index ? '' : '目的地国家'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'demandInfo', index, 'countryId']"
          >
            <ParamCodesSelect
              v-model:value="item.countryId"
              :options="paramCodeData.lbu_demand_country"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              allowClear
            />
          </dc-form-item>
          <dc-form-item :label="index ? '' : '出货渠道'"
                        :class="index ? 'no-form-label' : ''"
                        :name="['business', 'demandInfo', index, 'shippingChannel']"
                        >
            <ParamCodesSelect
              v-model:value="item.shippingChannel"
              :options="paramCodeData.lbu_shipping_channel"
              :disabled="!isEdit"
              :view="props.type === 'view'"
              mode="multiple"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : 'TPR（票数/月）'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'demandInfo', index, 'potentialBusinessVolume']"
          >
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>潜力业务量（票数/月）</p>
                </template>
                <span>{{ `${index ? '' : 'TPR（票数/月）'}` }}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
              </a-tooltip>
            </template>
            <CosInputNumber
              v-model:value="item.potentialBusinessVolume"
              :min="0"
              :maxlength="15"
              cos-type="money"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              style="width: 100%"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : 'TPR（元/月）'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'demandInfo', index, 'amount']"
          >
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>发货潜力（元/月）</p>
                </template>
                <span>{{ `${index ? '' : 'TPR（元/月）'}` }}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
              </a-tooltip>
            </template>
            <CosInputNumber
              v-model:value="item.amount"
              :min="0"
              :maxlength="15"
              cos-type="money"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              style="width: 100%"
            />
          </dc-form-item>

          <dc-form-item
            :label="index ? '' : 'TPR（KG/月）'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'demandInfo', index, 'tprWeight']"
          >
            <template #label>
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <p>发货潜力（KG/月）</p>
                </template>
                <span>{{ `${index ? '' : 'TPR（KG/月）'}` }}</span>
                <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
              </a-tooltip>
            </template>
            <div class="flex">
              <CosInputNumber
                v-model:value="item.tprWeight"
                :min="0"
                :maxlength="15"
                cos-type="money"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.business.demandInfo && dataForm.business.demandInfo.length > 1"
                @click="handleDemandInfoDel(index)"
              >删除
              </a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="24"/>
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="物流商（务必填写云途份额）" :span="6">
      <template #title>
        <div style="display: flex; align-items: center; height: 24px; margin-bottom: 13px">
          <div class="dc-card-header-defaut-line"></div>
          <p style="font-size: 16px; font-weight: 500">物流商</p>
          <span style="color: #999; font-size: 12px">（务必填写云途份额）</span>
          <template v-if="props.isEdit">
            <div style="flex: 1 1 0%; text-align: right">
              <a-button type="primary" ghost @click="handleAddCol(dataForm.business.logisticsProviderInfo)">新增
              </a-button>
            </div>
          </template>
        </div>
      </template>
      <MultipleItem :view="props.type === 'view'" :line="false">
        <template v-for="(item, index) in dataForm.business.logisticsProviderInfo" :key="index">
          <dc-form-item
            :label="index ? '' : '当前物流商'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'logisticsProviderInfo', index, 'currentLogisticsProvider']"
            :rules="[{ required: isPerfect, validator: (rule:any, value:number) => checkValidate(rule, value, dataForm.business.logisticsProviderInfo, 'percent', '请选择') }]"
          >
            <ParamCodeCascader
              v-model:value="item.currentLogisticsProvider"
              :options="paramCodeData.lbu_logistics_service_provider"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              allowClear
              @change="onLogisticsProviderSelect(item, index)"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '物流商占比(%)'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'logisticsProviderInfo', index, 'percent']"
            :rules="[{ required: isPerfect, validator: (rule, inputValue) => logisticsProviderInfoValidate(rule,inputValue,item)}]"
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.percent"
                :min="0"
                :disabled="!props.isEdit"
                @change="onLogisticsProviderInput"
                :view="props.type === 'view'"
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.business.logisticsProviderInfo && dataForm.business.logisticsProviderInfo.length > 1"
                @click="handleDelCol(dataForm.business.logisticsProviderInfo, index)"
              >删除
              </a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12"/>
        </template>
      </MultipleItem>
    </dc-layout-card>

    <dc-layout-card title="货物品类" :span="6">
      <template #subTitle v-if="props.isEdit">
        <a-button type="primary" ghost @click="handleAddCol(dataForm.business.goodsCategoryInfo)">新增</a-button>
      </template>
      <MultipleItem :view="props.type === 'view'" :line="false">
        <template v-for="(item, index) in dataForm.business.goodsCategoryInfo" :key="index">
          <dc-form-item
            :label="index ? '' : '货物品类'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'goodsCategoryInfo', index, 'goodsCategory']"
            :rules="[{ required: isPerfect, validator: (rule:any, value:number) => checkValidate(rule, value, dataForm.business.goodsCategoryInfo, 'percent', '请选择') }]"
          >
            <ParamCodesSelect
              v-model:value="item.goodsCategory"
              :options="paramCodeData.lbu_sales_category"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              allowClear
              @change="onGoodsCategorySelect(item,index)"
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '品类占比(%)'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'goodsCategoryInfo', index, 'percent']"
            :rules="[{ required: isPerfect, validator: (rule, inputValue) => goodsCategoryInfoValidate(rule,inputValue,item) }]"
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.percent"
                :min="0"
                @change="onGoodsCategoryInput"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.business.goodsCategoryInfo && dataForm.business.goodsCategoryInfo.length > 1"
                @click="handleDelCol(dataForm.business.goodsCategoryInfo, index)"
              >删除
              </a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12"/>
        </template>
      </MultipleItem>
    </dc-layout-card>

    <dc-layout-card title="ERP系统" :span="6">
      <template #subTitle v-if="props.isEdit">
        <a-button type="primary" ghost @click="handleErpInfoAdd()">新增</a-button>
      </template>
      <MultipleItem :view="props.type === 'view'" :line="false">
        <template v-for="(item, index) in dataForm.business.erpInfo" :key="index">
          <dc-form-item
            :label="index ? '' : 'ERP系统'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'erpInfo', index, 'erpId']"
            :rules="[
            { validator: (rule:any, value:number) => checkValidate(rule, value, dataForm.business.erpInfo, 'erpAccount', '请选择') }
          ]"
          >
            <ParamCodesSelect
              v-model:value="item.erpId"
              :options="paramCodeData.lbu_erp_info"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              allowClear
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '关联账号'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'erpInfo', index, 'erpAccount']"
            :rules="[
            { validator: (rule:any, value:number) => checkValidate(rule, value, dataForm.business.erpInfo, 'erpId', '请输入') }
          ]"
          >
            <div class="flex">
              <CosInput
                v-model:value="item.erpAccount"
                :maxlength="100"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.business.erpInfo && dataForm.business.erpInfo.length > 1"
                @click="handleErpInfoDel(index)"
              >删除
              </a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12"/>
        </template>
      </MultipleItem>
    </dc-layout-card>
    <dc-layout-card title="其他信息" :span="6">
      <dc-form-item
        label="无效原因"
        name="invalidId"
        :rules="dataForm.clueStatus === 5 ? formRules.invalid : []"
        v-if="dataForm.clueStatus === 5"
      >
        <ParamCodesSelect
          v-model:value="dataForm.invalidId"
          :options="paramCodeData.lbu_invalid_reason"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="上传附件" name="attachment" :span="24">
        <UploadFile v-model:value="dataForm.attachment" :disabled="!props.isEdit"/>
      </dc-form-item>
      <dc-form-item
        label="备注"
        :span="12"
        name="remark"
        :rules="dataForm.clueStatus === 5 ? formRules.remarkValue : []"
      >
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>

  <cos-footer-button
    v-model:value="dataForm"
    :formRef="formRef"
    :resetValue="resetValue"
    :loading="loading"
    :disabled="!props.isEdit"
    :permissionPage="permissionPage"
    @submit="handleSubmit"
  />
</template>

<script setup lang="ts">
import { ref, reactive, computed, onBeforeMount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { cloneDeep } from 'lodash-es'
import { contactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import UploadFile from '@/components/UploadFile'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { businessTypeEnum, customerTypeEnum, linkRoleTypeEnum, genderEnum, flagEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { clueStatusEnum } from '@/views/yuntuSales/clueManage/dataConfig'
import { listByParamCodes, fetchUsersByWorkCode } from '@/api/common'
import { salesClueCreate, salesClueEdit } from '@/api/yuntuSales/clueManage'
import calc from '@/utils/calc'
import { initObjectVal, clearInvalid, paramCodesDataFilter } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuSalesClueEditParams } from '@/typings/api/clueManage'
import MapModal from '@/components/MapModal/index.vue'
import {
  checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel,
  clear
} from '@/hooks/addressArrValidate'
import CosInputTianyancha from '@/components/Antd/CosInputTianyancha/index.vue'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import CosInput from '@/components/Antd/CosInput/index.vue'
import { isChannelDisabled } from '@/hooks/useChannel'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import { ValidateOptions } from 'ant-design-vue/lib/form/interface'
import { ComponentInternalInstance } from 'vue/dist/vue'
import { error } from 'echarts/types/src/util/log'

const router = useRouter()
const route = useRoute()

const props = defineProps({
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'view'].includes(value)
    }
  },
  resetValue: {
    type: [Object, Array]
  }
})
const clearMainAddressFlag = (index: number) => {
  if (dataForm.visitAddress) {
    for (const [i, item] of dataForm.visitAddress.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}
const permissionPage = computed(() => {
  return props.type === 'add'
    ? { save: 'lbu_clue_add_btn' }
    : {
        edit: 'lbu_clue_edit_btn',
        save: 'lbu_clue_edit_btn'
      }
})

const totalTprWeight = computed(() => {
  const result = dataForm.business.demandInfo?.reduce((sum, item) => {
    return calc.Add(sum, item.tprWeight || 0)
  }, 0)
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})

const tprTotal = computed(() => {
  const result = dataForm.business.demandInfo?.reduce((sum, item) => {
    return calc.Add(sum, item.amount || 0)
  }, 0)
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})
const tprPotential = computed(() => {
  const result = dataForm.business.demandInfo?.reduce(
    (prev: number, item: any) => calc.Add(prev, item.potentialBusinessVolume || 0),
    0
  )
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})
const initForm = reactive<LbuSalesClueEditParams.RootObject>({
  contact: {},
  duplicateConfirmFlag: false,
  business: {
    saleInfo: [{}],
    demandInfo: [{}],
    erpInfo: [{}],
    goodsCategoryInfo: [{}],
    logisticsProviderInfo: [{}]
  },
  visitAddress: [{}]
})

// 线索状态枚举
const clueStatusEnumComputed = computed(() => {
  let list: any[] = []
  if (props.type === 'add') {
    list = clueStatusEnum.filter((item) => item.value === 3 || item.value === 6)
  } else if (props.type === 'edit') {
    list = clueStatusEnum.filter((item) => item.value === 3 || item.value === 5 || item.value === 6)
  } else {
    list = clueStatusEnum.filter((item) => item.value)
    list.unshift({
      label: '待领取',
      value: 0
    }) // 为了处理从线索公海池跳转过来的情况
  }
  return list
})
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  lbu_department_title: [], // 职务
  lbu_customer_business_area: [], // 客户业务地区
  lbu_important: [], // 业务收入等级（月潜在收入）
  lbu_sales_category: [], // 销售品类
  lbu_cargo_type: [], // 货物类型
  lbu_logistics_service_provider: [], // 现有合作物流服务商
  lbu_shipping_channel: [], // 出货渠道
  lbu_daily_traffic: [], // 客户日均包裹数量
  lbu_sale_platform: [], // 在售电商平台
  lbu_demand_country: [], // 目的地国家（需求国家）
  lbu_erp_info: [], // ERP系统
  lbu_invalid_reason: [], // 无效原因,
  lbu_source_channel: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_department_title',
      'lbu_customer_business_area',
      'lbu_important',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_sale_platform',
      'lbu_demand_country',
      'lbu_erp_info',
      'lbu_invalid_reason',
      'lbu_sign_in_address_label',
      'lbu_source_channel'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)

    if (props.isEdit) {
      channelDisabled.value = isChannelDisabled(paramCodeData.lbu_source_channel, dataForm.channel)
    }
  })
}
onBeforeMount(() => {
  getByParamCodes()
})
// 获取当前用户的信息
const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.lbuCustomerRegion != null) {
      dataForm.customerRegion = followerInfo.lbuCustomerRegion
    } else {
      dataForm.customerRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('customerRegion'))
    }
  })
}

const formRef = ref<FormInstance>()
const isFutureClue = ref(false)
const queryClueId = computed(() => route.query.clueId as string)
const dataForm = reactive<LbuSalesClueEditParams.RootObject>(cloneDeep(initForm))

const channelDisabled = ref(false)

const isPerfect = ref(false)
const formRules: Record<string, Rule[]> = {
  businessType: [{
    required: true,
    message: '请选择'
  }],
  select: [{
    required: true,
    message: '请选择'
  }],
  selectNumber: [{
    required: true,
    validator: selectForNumberValidate,
    message: '请选择'
  }],
  input: [{
    required: true,
    message: '请输入'
  }],
  customerName: [{
    required: true,
    message: '请输入客户名称'
  }],
  clueStatus: [{
    required: true,
    validator: selectForNumberValidate,
    message: '请选择线索状态'
  }],
  channel: [{
    required: true,
    message: '请选择线索来源'
  }],
  follower: [{
    required: true,
    message: '请选择客户负责人'
  }],
  customerType: [{
    required: true,
    validator: selectForNumberValidate,
    message: '请选择客户类型'
  }],
  customerRegion: [{
    required: true,
    message: '请选择客户区域'
  }],
  futureContactTime: [{
    required: true,
    message: '请选择未来联系时间'
  }],
  contactName: [{
    required: true,
    message: '请输入联系人姓名'
  }, { validator: concatNameValidate }],
  invalid: [{
    required: true,
    message: '请选择无效原因'
  }],
  remarkValue: [{
    required: true,
    message: '请输入备注'
  }]
}
watch(
  () => route.query.isPerfect,
  (val) => {
    if (val === 'required') {
      isPerfect.value = true
    }
  },
  { immediate: true }
)
watch(
  () => dataForm.clueStatus,
  (val) => {
    // 控制未来线索必填校验
    if (val === 6) {
      isFutureClue.value = true
    } else {
      isFutureClue.value = false
      dataForm.futureContactTime = undefined
    }
  },
  { immediate: true }
)
watch(
  () => props.value,
  (val) => {
    if (val) {
      const formVal = {
        ...val
      }
      initObjectVal(formVal, initForm)
      if (!formVal.business.monthIncome) {
        formVal.business.monthIncome = undefined
      }
      if (formVal.business.saleInfo.length) {
        formVal.business.saleInfo.forEach((item: any) => {
          if (!item) return
          if (item.salePlatformId != null) {
            item.salePlatformId = item.salePlatformId || undefined
          }
          if (item.percent === null) item.percent = undefined
        })
      }
      if (formVal.business.demandInfo.length) {
        formVal.business.demandInfo.forEach((item: any) => {
          if (!item) return
          if (item.countryId != null) {
            item.countryId = item.countryId || undefined
          }
          if (item.amount === null) item.amount = undefined
          if (item.potentialBusinessVolume === null) item.potentialBusinessVolume = undefined
          if (item.shippingChannel === null) item.shippingChannel = undefined
        })
      }
      if (formVal.business.erpInfo.length) {
        formVal.business.erpInfo.forEach((item: any) => {
          if (!item) return
          if (item.erpId != null) {
            item.erpId = item.erpId || undefined
          }
          item.erpAccount = item.erpAccount || undefined
        })
      }
      Object.assign(dataForm, clearInvalid(formVal))
    }
  },
  {
    immediate: true,
    deep: true
  }
)

const handleFollowerChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const checkValidate = (rule: any, value: number | string, arr: any, name: string, message: string) => {
  const index = rule.field.split('.').slice(-2)[0] * 1
  const list = arr || []
  let key = list[index][name]
  if (['countryId', 'erpId'].includes(name) && key === -9) key = undefined

  // 选择“ERP”时不需要校验“关联账号”
  if (name === 'erpId') {
    return Promise.resolve()
  }

  if (key != null && key !== '' && (!value || value === -9)) {
    return Promise.reject(new Error(message))
  } else {
    return Promise.resolve()
  }
}
const percentValidate = async (rule: any, value: number, item: any) => {
  if (isPerfect.value) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入在售平台占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.salePlatformId && item.salePlatformId !== -9) ? Promise.reject(new Error('请输入在售平台占比')) : Promise.resolve()
    }
  }
  const result = dataForm.business.saleInfo?.reduce((prev: number, curr: any) => calc.Add(prev, curr.percent || 0), 0)
  if (value && result !== 100) {
    return Promise.reject(new Error('在售平台占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onSalesSelect = async (item: any, index: any) => {
  if (item.salePlatformId === null || item.salePlatformId === -9) {
    formRef.value?.validate([['business', 'saleInfo', index, 'percent']])
  }
}
/// 用来校验多个列表的输入框加起来要等于100之后让validator提示消失
const onSalesInput = async () => {
  const salesList = dataForm.business.saleInfo
  const validList = salesList?.map((item: any, index: number) => {
    if (item.salePlatformId != null && item.percent != null) {
      return ['business', 'saleInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const logisticsProviderInfoValidate = async (rule: Rule, value: number, item: any) => {
  if (isPerfect.value) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入物流商占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.currentLogisticsProvider && item.currentLogisticsProvider !== -9) ? Promise.reject(new Error('请输入物流商占比')) : Promise.resolve()
    }
  }
  let result = 0
  if (dataForm.business && dataForm.business.logisticsProviderInfo) {
    result = dataForm.business?.logisticsProviderInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, curr.percent || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('物流商占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onLogisticsProviderSelect = async (item: any, index: any) => {
  if (item.currentLogisticsProvider === null || item.currentLogisticsProvider === -9) {
    formRef.value?.validate([['business', 'logisticsProviderInfo', index, 'percent']])
  }
}
const onLogisticsProviderInput = async () => {
  const logistics = dataForm.business.logisticsProviderInfo
  const validList = logistics?.map((item: any, index: number) => {
    if (item.currentLogisticsProvider != null && item.percent != null) {
      return ['business', 'logisticsProviderInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const goodsCategoryInfoValidate = async (rule: Rule, value: number, item: any) => {
  if (isPerfect.value) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入品类占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.goodsCategory && item.goodsCategory !== -9) ? Promise.reject(new Error('请输入品类占比')) : Promise.resolve()
    }
  }
  let result = 0
  if (dataForm.business && dataForm.business.goodsCategoryInfo) {
    result = dataForm.business?.goodsCategoryInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, curr.percent || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('品类占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onGoodsCategorySelect = async (item: any, index: any) => {
  if (item.goodsCategory === null || item.goodsCategory === -9) {
    formRef.value?.validate([['business', 'goodsCategoryInfo', index, 'percent']])
  }
}
const onGoodsCategoryInput = async () => {
  const goodsCategoryInfos = dataForm.business.goodsCategoryInfo
  const validList = goodsCategoryInfos?.map((item: any, index: number) => {
    if (item.goodsCategory != null && item.percent != null) {
      return ['business', 'goodsCategoryInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}
const handleSalePlatformAdd = () => {
  dataForm.business.saleInfo?.push({
    salePlatformId: undefined,
    percent: undefined
  })
}
const handleSalePlatformDel = (index: number) => {
  dataForm.business.saleInfo?.splice(index, 1)
}
const handleDemandInfoAdd = () => {
  dataForm.business.demandInfo?.push({
    countryId: undefined,
    amount: undefined,
    potentialBusinessVolume: undefined,
    shippingChannel: undefined
  })
}
const handleDemandInfoDel = (index: number) => {
  dataForm.business.demandInfo?.splice(index, 1)
}
const handleErpInfoAdd = () => {
  dataForm.business.erpInfo?.push({
    erpId: undefined,
    erpAccount: undefined
  })
}
const handleErpInfoDel = (index: number) => {
  dataForm.business.erpInfo?.splice(index, 1)
}

const goBack = () => {
  if (location.hostname === 'localhost') {
    router.back()
  } else {
    layoutTags.close()
  }
}

const loading = ref(false)
const handleSubmit = async () => {
  try {
    loading.value = true
    const params: any = cloneDeep(dataForm)
    // 联系方式为空的字段需要删除，否则接口会报错
    // for (const key in params.contact) {
    //   if (params.contact[key] === '' || params.contact[key] == null) delete params.contact[key]
    // }
    // params.business.tpr = tprTotal
    // 地址为空清除、判断地址是否重复
    if (checkAddressData(dataForm.visitAddress)) {
      message.error('签到地址不可重复！')
      loading.value = false
      return false
    }
    const { visitAddress } = params
    params.visitAddress = clear(visitAddress, ['addressName', 'geoPoint'])
    // 新增、编辑的格式和详情不同、多传attrList
    if (JSON.stringify(params.visitAddress) === '[{}]') {
      params.visitAddress = { attrList: [] }
    } else {
      params.visitAddress = { attrList: params.visitAddress }
    }
    params.business.tpr = params.business.demandInfo?.reduce((sum: number, item: any) => {
      if (item.amount != null) {
        return calc.Add(sum, item.amount || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    params.business.totalPotential = params.business.demandInfo?.reduce((sum: number, item: any) => {
      if (item.potentialBusinessVolume != null) {
        return calc.Add(sum, item.potentialBusinessVolume || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    params.business.saleInfo = params.business.saleInfo?.filter((item: any) => {
      return item.salePlatformId != null && item.percent != null
    })
    params.business.demandInfo = params.business.demandInfo?.filter((item: any) => {
      const allNull = item.countryId === null && item.amount === null && item.potentialBusinessVolume === null && item.shippingChannel === null
      return !allNull
    })
    params.business.erpInfo = params.business.erpInfo?.filter((item: any) => {
      return item.erpId != null
    })
    params.business.goodsCategoryInfo = params.business.goodsCategoryInfo?.filter((item: any) => {
      return item.goodsCategory != null && item.percent != null
    })
    params.business.logisticsProviderInfo = params.business.logisticsProviderInfo?.filter((item: any) => {
      return item.currentLogisticsProvider != null && item.percent != null
    })
    if (queryClueId.value) {
      params.id = queryClueId.value
      const data = await salesClueEdit(params, { custom: { errorMsg: false } })
      if (data.code === 200) {
        message.success('修改线索成功')
        goBack()
      } else if (data.code === 12000002) {
        DcConfirm.warning({
          title: '操作提示！',
          content: `${data.message}，是否继续提交？`,
          cancelText: '取消',
          okText: '继续',
          onOk() {
            params.duplicateConfirmFlag = true
            salesClueEdit(params).then(() => {
              message.success('修改线索成功')
              goBack()
            })
          }
        })
      } else {
        message.error(data.message)
      }
    } else {
      const data = await salesClueCreate(params, { custom: { errorMsg: false } })
      if (data.code === 200) {
        message.success('新增线索成功')
        goBack()
      } else if (data.code === 12000002) {
        DcConfirm.warning({
          title: '操作提示！',
          content: `${data.message}，是否继续提交？`,
          cancelText: '取消',
          okText: '继续',
          onOk() {
            params.duplicateConfirmFlag = true
            salesClueCreate(params).then(() => {
              message.success('新增线索成功')
              goBack()
            })
          }
        })
      } else {
        message.error(data.message)
      }
    }
  } catch (errorInfo: any) {
    loading.value = false
    formRef.value?.scrollToField(errorInfo.errorFields[0].name.toString())
  }
  loading.value = false
}
</script>
<script lang="ts">
export default { name: 'DetailForm' }
</script>
<style lang="scss" scoped>
:deep(.form-item_compact) {
  > .ant-form-item-control {
    .ant-form-item-explain {
      top: 100%;
    }
  }
}

:deep(.last-compact) {
  > .ant-form-item-control {
    .ant-form-item-explain {
      top: 100%;
    }
  }
}
</style>
